import type { ReactElement } from 'react';

import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './PaychexLoginForm.scss';

type PaychexLoginBannerProps = {
    className?: string;
};

const PaychexLoginBanner = ({
    className = '',
}: PaychexLoginBannerProps): ReactElement => (
    <div className={getClassName(styles['login-banner'], className)}>
        Your information already exists in our system. Please log in to connect
        your account with Paychex
    </div>
);

export default PaychexLoginBanner;
